export default __webpack_public_path__ + "static/media/Create-documentation.5db09a11.md";